module.exports = __webpack_public_path__ + "img/L3_Door.266fda54.svg";